/* src/hooks/useWorkspaceSmsLive.js
 * Workspace-scoped SMS live state (active number + A2P approved).
 * Used for copy that differs between live workspaces (e.g. GAM) and pre-launch.
 */

import { useState, useEffect } from 'react';
import { smsApi } from '../utils/api';

/** True when workspace has two-way SMS live in production. */
export function isSmsNumberLive(smsNumber) {
  return smsNumber?.status === 'active' && smsNumber?.a2p?.status === 'approved';
}

export function useWorkspaceSmsLive(workspaceId) {
  const [live, setLive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [smsNumber, setSmsNumber] = useState(null);

  useEffect(() => {
    if (!workspaceId) {
      setLive(false);
      setSmsNumber(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    smsApi
      .getSmsStatus(workspaceId)
      .then((res) => {
        if (cancelled) return;
        const sn = res.smsNumber || null;
        setSmsNumber(sn);
        setLive(isSmsNumberLive(sn));
      })
      .catch(() => {
        if (!cancelled) {
          setLive(false);
          setSmsNumber(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  return { live, loading, smsNumber };
}
